import adminEntry from './account/myAccount.svelte';

const app = new adminEntry({
	target: document.getElementById('svelte'),
	});